import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  z-index: 2;
  background-color: ${props => props.theme.colors[props.color]};

  &:before,
  &:after {
    content: "";
    width: 100%; 
    height: 100px;
    position: absolute;
  }

  &:before {
    top: -100px;
    left: 0;
    background: linear-gradient(
      to bottom right,
      transparent 0%,
      transparent 50%,
      ${props => props.theme.colors[props.color]} 50%,
      ${props => props.theme.colors[props.color]} 100%
    );
  }

  &:after {
    bottom: -100px;
    left: 0;
    background: linear-gradient(
      to top left,
      transparent 0%,
      transparent 50%,
      ${props => props.theme.colors[props.color]} 50%,
      ${props => props.theme.colors[props.color]} 100%
    );
  }

  ${props => props.hideTopSlant && `
    &:before { display: none; }
  `}

  ${props => props.hideBottomSlant && `
    &:after { display: none; }
  `}
`;

const SlantedContainer = ({
  children,
  color,
  hideTopSlant,
  hideBottomSlant,
}) => (
  <Container
    color={color}
    hideTopSlant={hideTopSlant}
    hideBottomSlant={hideBottomSlant}
  >{children}</Container>
);

SlantedContainer.propTypes = {
  color: PropTypes.string,
  hideTopSlant: PropTypes.bool,
  hideBottomSlant: PropTypes.bool,
};

SlantedContainer.defaultProps = {
  color: 'background2',
  hideTopSlant: false,
  hideBottomSlant: false,
};

export default SlantedContainer;
